var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6384 7.50697C17.4353 7.28586 17.2201 7.07072 16.993 6.86155L16.6434 4.41434C15.9514 4.01469 15.21 3.7073 14.4382 3.5L12.4572 4.98805C12.153 4.96115 11.847 4.96115 11.5428 4.98805L9.56175 3.5C8.79029 3.70826 8.04906 4.0156 7.35657 4.41434L7.00697 6.86155C6.78586 7.07072 6.57072 7.28586 6.36155 7.50697L3.91434 7.85657C3.51469 8.54861 3.2073 9.28996 3 10.0618L4.48805 12.0428C4.46116 12.3476 4.48805 12.9572 4.48805 12.9572L3 14.9382C3.20826 15.7097 3.5156 16.4509 3.91434 17.1434L6.36155 17.493C6.57072 17.7141 6.78586 17.9293 7.00697 18.1384L7.35657 20.5857C8.04861 20.9853 8.78996 21.2927 9.56175 21.5L11.5428 20.012C11.847 20.0389 12.153 20.0389 12.4572 20.012L14.4382 21.5C15.2097 21.2917 15.9509 20.9844 16.6434 20.5857L16.993 18.1384C17.2171 17.9323 17.6384 17.493 17.6384 17.493L20.0857 17.1434C20.4853 16.4514 20.7927 15.71 21 14.9382L19.512 12.9572C19.5388 12.6524 19.512 12.0428 19.512 12.0428L21 10.0618C20.7917 9.29029 20.4844 8.54906 20.0857 7.85657L17.6384 7.50697Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16Z",
    stroke: "#EFEFEF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.411e6f62157e87ec02a887bb941afb86.svg";
export { ForwardRef as ReactComponent };